import { combineReducers } from 'redux';

import catalog from './catalog';
import cart from './cart';
import order from './order';
// import history from './history';


export default combineReducers({
  catalog,
  cart,
  order,
  // history,
});
